import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bugReportsReason'
})
export class BugReportsReasonPipe implements PipeTransform {

  private listObj = {
    1: 'Performance issues',
    2: 'Functional issues',
    3: 'User Interface (UI) issues',
    4: 'User Experience (UX) issues',
    5: 'Network or Connectivity issues',
    6: 'Localization or Internationalization issues',
    7: 'Other',

  };

  transform(value: number): string {
    console.log("transforming: ", value)
    return this.listObj.hasOwnProperty(value) ? this.listObj[value] : '';
  }

}
